module.exports = __webpack_public_path__ + "static/media/add campus.e747e15e.svg";